import enLocale from 'element-ui/lib/locale/lang/en';
import enPrototypes from '@/prototypes/index.lang.en';
import enValidator from './en_validator';

export default {
  ...enLocale,
  ...enPrototypes,
  ...enValidator,

  // Common
  Type: 'Type',
  'Account Name': 'Account Name',
  'Account ID': 'Account ID',
  'Usage Details': 'Usage Details',
  'Something went wrong !': 'Something Went Wrong!',

  // Header
  Documents: 'Documents',

  // Dashboard
  'Report data': 'Report data',
  'Invoice data': 'Invoice data',
  Preparing: 'Preparing...',
  'Preparing data': 'Preparing data...',

  // Chart
  Range: 'Range',
  Category: 'Category',
  Cost: 'Cost',
  'Show total': 'Show total',
  Filter: 'Filter',
  FILTER: 'FILTER',
  Daily: 'Daily',
  Monthly: 'Monthly',
  Service: 'Service',
  Account: 'Account',
  Blended: 'Blended',
  Unblended: 'Unblended',
  'True Unblended': 'True Unblended',
  'Select All': 'Select All',
  'Deselect All': 'Unselect All',
  'Search service by name': 'Search service by name',

  // Summary
  total: 'Total',
  average: 'Average',

  // Change Password
  Password: 'Password',
  '{min}~{max} characters': '{min}~{max} characters',
  'New Password': 'New Password',
  Confirm: 'Confirm',
  'Confirm Password': 'Confirm Password',
  'Confirm submit': 'Confirm',
  Back: 'Back',
  'Reset password': 'Reset password',
  'Check email address': 'Check email address',
  'Verification code': 'Verification code',
  Reset: 'Reset',
  'Please type email address.': 'Please type email address.',
  'This email address does not exist.': 'This email address does not exist.',
  'An error has occurred.': 'An error has occurred.',
  'Verification code will be sent to the email address you typed.':
    'Verification code will be sent to the email address you typed.',
  'Please enter a email address to the form below.':
    'Please enter a email address to the form below.',
  'Six digits verification code will be sent to the email address from Alphaus.':
    'Six digits verification code will be sent to the email address from Alphaus.',
  'The verification code is valid for 900 seconds.':
    'The verification code is valid for 900 seconds.',
  'If the verification code is expired, send the email again.':
    'If the verification code is expired, send the email again.',
  'Send email again.': 'Send email again.',
  'Six-digit verification code': 'Six-digit verification code',
  'Type Six-digit verification code.': 'Type Six-digit verification code.',
  'This is wrong verification code.': 'This is wrong verification code.',
  'Type new password.': 'Type new password.',
  'Change password': 'Change password',
  'Failed to change password.': 'Failed to change password.',
  'Password was reset.': 'Password was reset.',
  'Go to login page.': 'Go to login page.',

  // Change Login ID
  'Email address is already exist.': 'Email address is already exist.',

  // Upper menu
  Settings: 'Settings',

  // Notification Settings
  //'Notification destination setting': 'Notification destination setting',
  //'Email address': 'Email address',
  //Slack: 'Slack',
  //'Email notification': 'Email notification',
  //'Slack notification': 'Slack notification',
  //'Please enter the correct e-mail address.': 'Please enter the correct e-mail address.',
  //'Please enter the correct URL.': 'Please enter the correct URL.',
  //"Please check Slack's webhooks documentation for further information.":
  //  "Please check Slack's webhooks documentation for further information.",

  // Additional Settings
  'Past setting': 'Previous Setting',
  'The rate you entered here are used for monthly usage & report generation (the csv you can download).On UI it will by default showing the original USD price.':
    'The rate you entered here are used for monthly usage & report generation (the csv you can download).On UI it will by default showing the original USD price.',

  // User setting
  //'Open sub user management': 'Open sub user management',

  // Account
  Accounts: 'Accounts',
  'Payer account': 'Payer account',
  'Account menu': 'Account menu',
  // 'Account information': 'Account information',
  'Edit account info': 'Edit account info',
  //'You can download whole account report in one csv. Select the month and click "Bulk download".':
  //  'You can download whole account report in one csv. Select the month and click "Bulk download".',
  //'No existing data.': 'No existing data.',
  //'Bulk download': 'Bulk download',
  //'Report bulk download': 'Report bulk download',
  //'Select the month': 'Select the month',
  'Search account': 'Search account',
  'Download report': 'Download report',
  'Download the selected report (.csv)': 'Download the selected report (.csv)',
  'Setup a limit on your AWS account monthly and daily spending. Notify you when reaching the limit.':
    'Setup a limit on your AWS account monthly and daily spending. Notify you when reaching the limit.',
  //'Extra information': 'Extra information',
  'Owns Active RI': 'Owns Active RI',
  //Subscription: 'Subscription',
  //Credit: 'Credit',
  //Refund: 'Refund',
  //'You can check the fee for subscriptions payment, AWS credit, refund.':
  //  'You can check the fee for subscriptions payment, AWS credit, refund.',
  //'Any upfront annual fee that you paid like RI upfront fee, Marketplace fee.. etc':
  //  'Any upfront annual fee that you paid like RI upfront fee, Marketplace fee.. etc',
  //"Any credits that AWS applied to user's bill.": "Any credits that AWS applied to user's bill.",
  //'Negative charges that AWS refunded money to user for.':
  //  'Negative charges that AWS refunded money to user for.',

  // Group
  'Create new group': 'Create new group',
  'Account group': 'Account group',
  'Tag group': 'Tag group',
  'Group name': 'Group name',
  'Group name is required.': 'Group name is required.',
  'Account group? Tag Group?': 'Account group? Tag Group?',

  'Input group name': 'Input group name',
  'Please input group name.': 'Please input group name',
  'Up to 20 characters': 'Up to 20 characters',
  required: 'required',
  'Select account group or tag group.': 'Select account group or tag group.',
  'Choose account you want to add': 'Choose account you want to add',
  'Move the accounts you want to add into group to the right.':
    'Move the accounts you want to add into group to the right.',
  'Search group': 'Search group',

  // Tag
  Tag: 'Tag',
  'Tag name': 'Tag name',
  'Tag value': 'Tag value',
  'Tag values': 'Tag values',
  'Tag list': 'Tag list',
  'Select Tag Value to display': 'Select Tag Value to display (up to 50 tags)',
  'Select Tag Value': 'Please select tag value.',
  'No active tags': 'No active tags...',
  'No tag values': 'No tag values...',
  'Activated!': 'Activated!',
  'Tag values and usage data will be ready in two days.':
    'Tag valueと利用データの準備には２日程度かかります。',
  'Failed to get Tag value data.': 'Failed to get Tag value data.',
  'Select all': 'Select All',
  //'Save Changes': 'Save changes',
  Close: 'Close',
  Cancel: 'Cancel',
  'Search active tag': 'Search active tag',
  'Search inactive tag': 'Search inactive tag',
  'Select tag value': 'Select tag value',
  'Edit tag values': 'Edit tag values',
  'Save Filter': 'Save Filter',
  'Please note that the results shown in the "Preview" and "Show results" sections are based on the current month.':
    'Please note that the results shown in the "Preview" and "Show results" sections are based on the current month.',
  'Show Results': 'Show Results',
  Preview: 'Preview',

  // Budget
  //'Setting per day': 'Setting per day',
  //'Setting per month': 'Setting per month',
  //'Budget for a day': 'Budget for a day',
  //'Day-over-day changes': 'Day-over-day changes',
  //'Budget for a month': 'Budget for a month',
  //'Budget was set': 'Budget was set',
  //Percent: '%',
  //Dollar: '$',

  // Report Filters
  'Report Filters': 'Report Filters',

  // RI
  'Failed to get RI data.': 'Failed to get RI data.',
  instance_type: 'Instance Type',
  count: 'Count',
  start: 'Start',
  end: 'End',
  payment_options: 'Payment Option',
  upfront_value: 'Upfront Price',
  unblended_rate: 'Unblended Price',
  cycle_fee: 'Cycle Fee',
  Quantity: 'Quantity',
  account_name: 'Account name',
  account_id: 'Account ID',
  region: 'Region',
  scope: 'Scope',
  platform: 'Platform',
  'Active RI': 'Active RI',
  Expired: 'Expired',
  'Search RI': 'Search RI',
  "It will turn green when last month's report is ready.":
    "It will turn green when last month's report is ready.",
  "It will turn green when last month's invoice is ready.":
    "It will turn green when last month's invoice is ready.",
  'Copy to clipboard': 'Copy to clipboard',
  'Copied to clipboard': 'Copied to clipboard',
  'Add filter': 'Add filter',
  'usage time': 'Usage time',
  'covered time': 'Utilization time',
  'utilization rate': 'Utilization rate',
  'search ri': 'Search reserved instance',
  'more than 100': 'Over 100%',
  'search ri recommendation': 'Search RI recommendation',
  'on demand cost': 'On-demand cost',
  'discounted cost': 'Discounted cost',
  'Saving cost': 'Saving cost',
  Percentage: 'Percentage',
  'Current cost and discounted cost.': 'Current cost and discounted cost.',
  'average monthly discounted cost': 'Average monthly discounted cost',
  'average yearly discounted cost': 'Average yearly discounted cost',
  'Average monthly and yearly discounted cost estimate.':
    'Average monthly discounted cost and average yearly discounted cost estimates.',
  'Month selection': 'Month',
  Class: 'Class',
  'Select the class. (Currently only "standard" is supported)':
    'Select the class. (Currently only "standard" is supported)',
  Standard: 'Standard',
  Convertible: 'Convertible',
  standard: 'Standard',
  convertible: 'Convertible',
  'Select the payment option.': 'Select the payment option.',
  'All Upfront': 'All Upfront',
  'Partial Upfront': 'Partial Upfront',
  'No Upfront': 'No Upfront',
  Term: 'Term',
  '1 year': '1 year',
  '3 years': '3 years',
  // '1yr': '1 year',
  // '3yr': '3 years',
  'Select the term. (Currently only "1 year" is supported)':
    'Select the term. (Currently only "1 year" is supported)',
  Recommendation: 'Recommendation',
  'Recommendation (BETA)': 'Recommendation (BETA)',
  'size flexibility': 'Size flexibility',
  'normalization factor': 'Normalization factor',
  'Availability zone': 'Availability zone',
  'Cost before tax': 'Cost before tax',
  'Standard 1 year Partial upfront': 'Standard 1 year Partial upfront',
  'Standard 1 year Full upfront': 'Standard 1 year Full upfront',
  'Standard 1 year No upfront': 'Standard 1 year No upfront',
  'Standard 3 years Partial upfront': 'Standard 3 years Partial upfront',
  'Standard 3 years Full upfront': 'Standard 3 years Full upfront',
  'Standard 3 years No upfront': 'Standard 3 years No upfront',
  'Convertible 1 year Partial upfront': 'Convertible 1 year Partial upfront',
  'Convertible 1 year Full upfront': 'Convertible 1 year Full upfront',
  'Convertible 1 year No upfront': 'Convertible 1 year No upfront',
  'Convertible 3 years Partial upfront': 'Convertible 3 years Partial upfront',
  'Convertible 3 years Full upfront': 'Convertible 3 years Full upfront',
  'Convertible 3 years No upfront': 'Convertible 3 years No upfront',
  'Standard 1 year Medium': 'Standard 1 year Medium',
  'Standard 1 year Heavy': 'Standard 1 year Heavy',
  'Standard 3 years Medium': 'Standard 3 years Medium',
  'Standard 3 years Heavy': 'Standard 3 years Heavy',
  'Convertible 1 year Medium': 'Convertible 1 year Medium',
  'Convertible 1 year Heavy': 'Convertible 1 year Heavy',
  'Convertible 3 years Medium': 'Convertible 3 years Medium',
  'Convertible 3 years Heavy': 'Convertible 3 years Heavy',

  // Savings Plan
  'Savings Plan Type': 'Savings Plan Type',
  'Savings Plans': 'Savings Plans',
  Commitment: 'Commitment',
  'Instance Family': 'Instance Family',
  'Upfront Cost': 'Upfront Cost',
  'Monthly Recurring Charges': 'Monthly Recurring Charges',
  'Purchase Term': 'Purchase Term',
  'Active SP': 'Active SP',
  'Search Savings Plan': 'Search Savings Plan',
  'EC2 Instance on': 'EC2 Instance on',
  Compute: 'Compute',
  Hour: 'Hour',
  'Payment Option': 'Payment Option',
  Currency: 'Currency',
  '1yr': '1 year(s)',
  '3yr': '3 year(s)',
  'Purchase term': 'Purchase term',
  'All savings plan': 'All savings plan',
  'All payment options': 'All payment options',
  'All purchase terms': 'All purchase terms',
  'All regions': 'All regions',
  'All accounts': 'All accounts',
  ComputeSavingsPlans: 'Compute',
  EC2InstanceSavingsPlans: 'EC2 Instance',

  // Billing reports
  'Monthly total cost': 'Total Cost',
  // 'Usage Quantity': 'Usage Quantity',
  // 'Total Charge(USD)': 'Total Charge(USD)',
  // 'Type/Region': 'Type/Region',
  'Reserved Instance details': 'Reserved Instance details',

  text: {
    dashboard: 'Dashboard',
    login: 'Login',
    logout: 'Logout',
    username: 'Username',
    login_id: 'Login ID',
    password: 'Password',
    settings: 'Settings',
    change_settings: 'Change Settings',
    change: 'Edit',
    email_address: 'Mail Address',
    setting_email: 'Email Setting',
    current_password: 'Current Password',
    new_password: 'New password',

    language: 'Language', // コードのフッターに「備考」1をご参考。 - Please look at Remark 1 in the footer of source code
    //general_settings: 'General Settings',
    //user_settings: 'User settings',
    //account_settings: 'Account Settings',
    //security_settings: 'Security',
    //access_token_settings: 'API Access Tokens',
    //identity_provider_settings: 'Identity Provider Settings',
    //notification_settings: 'Notification Settings',
    private_price_setting: 'Private Pricing Settings',
    total: 'Total',
    updated: 'Updated',
    back_to_dashboard: 'Back to dashboard',
    instance_type: 'Instance Type',
    type: 'Type',
    region: 'Region',
    action: 'Actions',
    option: 'Option',

    expire: 'Expire',
    expired: 'Expired',
    details: 'Details',

    select_value: 'Select a value',
    last_month: 'Last Month',
    last_month_cost: 'Last month cost',
    last_last_month: 'Last last Month',
    diff_of_previous_month: 'Diff',
    diff_of_last_last_month: 'Changes to previous month',
    this_month: 'This Month',
    month_to_date: 'Month to date',
    yesterday: 'Yesterday',
    date: 'Date',

    show_more: 'Show more',
    services_all: 'All services',
    service_name: 'Service Name',

    download_csv: 'Download CSV',

    //usage
    usage_trend_this_month: 'Usage trend for this month',
    usage_daily_30days: 'Daily usage for the last 30 days',
    usage_ec2_total: 'EC2 total usage',
    usage_amount: 'Amount',

    // User Info
    company_id: 'Company ID',
    linked_account: 'Linked Account',
    usage_report: 'Usage Reports',
    account: 'Account',
    account_by: 'by account',
    account_name: 'Account Name',
    // account_name_edit: 'Edit account name',
    account_id: 'Account ID',
    account_list: 'Account List',
    account_add: 'Add new account',
    account_all: 'All accounts',
    account_add_to_group: 'Added to group',
    account_add_or_remove: 'Add/Remove Accounts',

    // General Settings
    save: 'Save',
    save_changes: 'Save Changes',
    close: 'Close',
    cancel: 'Cancel',
    notify_by_mail: 'Receive notification by email.',
    notify_by_slack: 'Receive notification by Slack.',
    enter_email: 'Enter your email address to receive notifications.',
    enter_slack: 'Enter "webhookURL" of your Slack account to receive notifications.',
    //enabled_notify: 'Notification enabled',
    additional_settings: 'Additional Settings',
    private_price_rate: 'Special price rate',
    exchange_rate: 'Exchange rate',
    discount_rate: 'Discount rate',

    // Account Settings
    //budget_setting: 'Budget settings',
    budget_daily: 'Daily budget',
    budget_monthly: 'Monthly budget',
    login_id_change: 'Change Login ID',

    // Chart Settings
    chart_settings: 'Chart settings',

    // Overview
    ec2_total: 'EC2 total usage',
    go_to_chart_settings: 'Change displayed services',

    // Group
    //group_by: 'by group',
    group_add: 'Add new group',
    group_edit: 'Edit group',
    //group_delete: 'Delete group',
    group_name: 'Group name',
    group_edit_name: 'Edit group name',

    // Chart
    monthly_trend: 'Monthly Trend',
    monthly_trend_desc: 'Trend of monthly spending based on accounts.',
    monthly_trend_desc_account: 'Trend of monthly spending of this account.',

    daily_trend: 'Daily Trend',
    daily_trend_desc: 'Trend of daily spending of all accounts.',
    daily_trend_desc_account: 'Trend of daily spending of this account.',

    daily_average: 'Daily Average',
    daily_cumulative: 'Cumulative',

    // RI
    ri: 'Reserved Instances',
    ri_purchased: 'Purchased',
    ri_utilization: 'Utilization',
    ri_covered: 'Covered',
    ri_uncovered: 'Uncovered',
    ri_top3_allocation: 'Top3 RI Allocation (As of last Month)',
    ri_allocation: 'RI Allocation',
    ri_show_all_coverages: 'Show all coverages',

    // Tag
    tag: 'by tag',
    tag_desc: 'You can view monthly trend by tags.',
    tag_name: 'Tag Name',
    tag_add: 'Add new tag',
    tag_delete: 'Delete Tag',
    tag_detach: 'Detach Tag',

    // Report
    report: 'Report',
    //report_desc: 'Monthly usage report by product.',
    report_desc2: 'Review usage report per account.',
    report_attention: 'ご利用明細が確定するまでの間、ご利用レポート詳細は参考情報となります。',

    // Invoice
    invoice_page: 'Invoice',
    invoice_download: 'Download invoice',
    invoice_desc_print: 'Print invoice describe',
    invoice_detail: 'Usage details',
    invoice_detail_download: 'Usage details',
    invoice_detail_print: 'Print usage details',
    invoice_detail_print_attention:
      'Use file/print menu if not work preview normaly.It is probrem of KB4032782 for IE only.',

    invoice: {
      billing_statement: 'Billing Statement',
      billing_items: 'items',
      tax: 'Tax',
      account_total: 'Account Total',
      sub_total: 'Sub total',
      after_discount: 'After discount',
      total: 'Total',
      exchange_total: 'After exchange',
      aws_usage: 'AWS Usage',
      substitution: 'Substitution',
      support_business: 'Support Business',
    },
    invoice003: {
      billing_statement: 'ご請求書',
      billing_items: '内訳',
      tax: '　　消費税等相当額',
      account_total: '利用料合計',
      account_usage: 'Charges:AWS利用料(MarketPlace利用料除く)',
      account_marketplace: 'Marketplace利用料金',
      sub_total: '小計（税抜）',
      discount_fee: '特別値引',
      after_discount: '値引き後小計 ',
      total: '合計（税込）',
      exchange_total: '日本円換算',
      aws_usage: 'AWS利用料',
      substitution: '請求代行サービス利用料金',
      support_business: 'AWS保守サービス利用料金',
    },
    menu: 'Menu',
    overview: 'Overview',
    account_ranking: 'Account Ranking',
    service_ranking: 'Service Ranking',
    daily: 'Daily',
    monthly: 'Monthly',
  },
  message: {
    no_data: 'No data',
    no_account: 'No account',
    no_group: 'There is no group. Please create a group.',
    no_tag: 'No tag is registered. Please  create tag(s).',
    no_active_tags: 'No active tags',
    no_inactive_tags: 'No inactive tags',
    no_ri_data: 'There is no RI history recorded.',
    no_ri_data_desc: 'Contact us in case there is a need to purchase RI.',

    // Group
    group_delete: 'Delete group',

    // Tag
    tag_detach: 'Detach this tag',
    release_limit_tag: 'Do you want to unlimit the number of Tags?？',
    supported_number_of_tags: 'Number of Tags supported in the current plan.',

    //can_not_be_canceled: "This operation can't be canceled.",
    all_data_be_deleted: 'All previous data will be deleted.',

    // Invoice
    invoice_is_not_ready: 'Invoice is not ready...',

    // Budget
    budget_message_02:
      '※Enter zero (0) or leave the field blank if you don’t need to set a budget.',

    //information
    info_daily_trend: 'RI discounts are not considered when calculating daily trend.',

    // Settings
    setting_rate: 'Enter discount rate and exchange rate which apply for last month usage.',
    check_private_price_settings: 'Review settings in previous months',
    setting_chart_settings_msg01:
      'You can choose up po 5 services which display in the chart on dashboard.',

    // Alert
    alert_this_month_data_no_yet_ready: "The data will be appeared when it's ready.",

    no_data_no_period: 'No data',
  },
  notification: {
    error: 'Error',
    success: 'Success!',
    failed: 'Failed',
    registered: 'Registered',
    released: 'Disconnected',
    saved_settings: 'Saved settings',
    changed_settings: 'Changed settings',
    changed_password: 'Changed password',
    changed_failed: 'Failed to change',
    input_password: 'Please enter password',
    password_wrong: 'Password is wrong',
    group_updated: 'Group updated',
    group_deleted: 'Group deleted',
    group_added: 'Added new group',

    tag_updated: 'Tag updated',

    // Auth
    auth_error: 'Access authentication error',
    auth_expire_msg: 'Please log-in again.',

    // Login
    //username_password_invalid: 'Username or Password is invalid.',

    // Tag
    tag_save_success: 'Tag was successfully saved.',
    tag_save_failed: 'Failed to save tag.',
    tag_delete_success: 'Tag was successfully deleted.',
    tag_delete_failed: 'Failed to delete tag.',

    // Additional settings
    private_price_rate_success: 'Saved private price setting.',
    login_id_change_success: 'Changed login ID.',
  },
  error_pages: {
    not_found: 'Not found.',
    not_found_content: 'This is not the web page you are looking for.',
    home: 'Home',
    internal_server_error: "We're having a really bad day.",
    // internal_server_error_content:
    //   "The Unicorns have taken over. We're doing our best to get them under control and get GitHub back up and running.",
    contact_support: 'Contact Support',
    go_back: 'Go back',
  },
};
